"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var WebOSInfo = (function (_super) {
    __extends(WebOSInfo, _super);
    function WebOSInfo(cache, window) {
        var _this = _super.call(this, cache) || this;
        _this.window = window;
        return _this;
    }
    WebOSInfo.prototype.load = function () {
        var _this = this;
        this.deviceBrand = 'LG';
        this.deviceVersion = null;
        this.deviceType = 'SmartTV';
        this.deviceManufacturer = 'LG';
        this.browserName = 'WebOS API';
        this.userFriendlyName = 'LG TV';
        this.operatingSystemName = 'WebOS';
        this.operatingSystemVersion = null;
        var systemInfoPromise = this.getSystemInfo().then(function (systemInfo) {
            _this.deviceModel = systemInfo.modelName;
            _this.browserVersion = "WebOS " + systemInfo.sdkVersion;
            if (systemInfo.boardType && systemInfo.boardType.split) {
                var boardTypeParts = systemInfo.boardType.split('_');
                if (boardTypeParts && boardTypeParts.length) {
                    _this.deviceVersion = boardTypeParts[0];
                }
            }
        });
        var uniqueDeviceIdPromise = this.initialise();
        return Promise.all([systemInfoPromise, uniqueDeviceIdPromise]);
    };
    WebOSInfo.prototype.isWebOS2 = function () {
        return this.browserVersion && !!this.browserVersion.match(/webos 2\.\d(\.\d)?/i);
    };
    WebOSInfo.prototype.getSystemInfo = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var request = _this.window.webOS.service.request('luna://com.webos.service.tv.systemproperty', {
                method: 'getSystemInfo',
                parameters: {
                    keys: ['modelName', 'firmwareVersion', 'UHD', 'sdkVersion'],
                },
                onComplete: resolve,
            });
        });
    };
    return WebOSInfo;
}(client_lib_js_player_addons_common_player_1.DeviceInfo));
exports.WebOSInfo = WebOSInfo;
